import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IFilterStrings extends LocalizedStringsMethods {
    isDailyTxt: string;
    isMonthlyTxt: string;
    isYearlyTxt: string;
    isCustomTxt: string;
    isOrgTxt: string;
    isRangeTxt: string;
    isAllTxt: string;
    isLoadTxt: string;
    isMoreTxt: string;
    isLessTxt: string;
    isTypeTxt: string;
    isProfileName: string;
    isTestScore: string;
    isTestThreshold: string;
    isIdTxt: string;
    isLevelTxt: string;
    isGenderTxt: string;
    isFirstnameTxt: string;
    isLastnameTxt: string;
    isMiddlenameTxt: string;
    isSportTxt: string;
    isClrFilterTxt: string;
}

let strings: IFilterStrings;
export default strings = new LocalizedStrings({
    en: {     
        isDailyTxt: 'Daily',
        isMonthlyTxt: 'Monthly',
        isYearlyTxt: 'Yearly',
        isCustomTxt: 'Custom',
        isOrgTxt: 'Organizations',
        isAdditionaInformationTxt: 'Additional Information',
        isShowAllTxt: 'Show All Tests',
        isShowFailedBaseline: 'Failed Baselines (Score > Low Average)',
        isShowFailedTest: 'Failed Tests (Score > 250,000)',
        isRangeTxt: 'Range',
        isAllTxt: 'All',
        isLoadTxt: 'Load Report',
        isClrFilterTxt: 'Clear Filter',
        isMoreTxt: 'More',
        isLessTxt: 'Less',
        isTypeTxt: 'Type',
        isProfileName: 'Profile Name',
        isTestScore: 'Score Range',
        isTestThreshold: 'Threshold',
        isIdTxt: 'Profile ID',
        isLevelTxt: 'Level',
        isGenderTxt: 'Gender',
        isFirstnameTxt: 'First Name',
        isLastnameTxt: 'Last Name',
        isMiddlenameTxt: 'Middle Name',
        isSportTxt: 'Sport',
    },
    es: {
        isDailyTxt: 'Diario',
        isMonthlyTxt: 'Mensual',
        isYearlyTxt: 'Anual',
        isCustomTxt: 'Personalizado',
        isOrgTxt: 'Organizaciones',
        isAdditionaInformationTxt: 'Información adicional',
        isShowAllTxt: 'Mostrar todas las pruebas',
        isShowFailedBaseline: 'Líneas de base fallidas (Score > Low Average)',
        isShowFailedTest: 'Pruebas fallidas (Score > 250,000)',
        isRangeTxt: 'Rango',
        isAllTxt: 'Todos',
        isLoadTxt: 'Cargar informe',
        isClrFilterTxt: 'Limpiar filtro',
        isMoreTxt: 'Más',
        isLessTxt: 'Menos',
        isTypeTxt: 'Tipo',
        isProfileName: 'Nombre de perfil',
        isTestScore: 'Puntuación',
        isTestThreshold: 'Umbral',
        isIdTxt: 'ID de perfil',
        isLevelTxt: 'Nivel',
        isGenderTxt: 'Género',
        isFirstnameTxt: 'Nombre',
        isLastnameTxt: 'Apellido',
        isMiddlenameTxt: 'Middle Name',
        isSportTxt: 'Deporte',
    }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/reports/string.filter.tsx